import * as React from "react";
import { Card, CardContent } from "../ui/card";
import { BarChart2, Calendar, PlusCircle } from "lucide-react";

export default function FeaturedSections() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <Card className="bg-green-50">
        <CardContent className="p-4 flex items-center justify-between">
          <div>
            <h3 className="font-semibold text-green-700">Monthly Budget</h3>
            <p className="text-sm text-green-600">
              Set and track monthly limits
            </p>
          </div>
          <Calendar className="w-6 h-6 text-green-600" />
        </CardContent>
      </Card>

      <Card className="bg-green-50">
        <CardContent className="p-4 flex items-center justify-between">
          <div>
            <h3 className="font-semibold text-green-700">Generate Report</h3>
            <p className="text-sm text-green-600">Download expense reports</p>
          </div>
          <BarChart2 className="w-6 h-6 text-green-600" />
        </CardContent>
      </Card>

      <Card className="bg-green-50">
        <CardContent className="p-4 flex items-center justify-between">
          <div>
            <h3 className="font-semibold text-green-700">Category Analysis</h3>
            <p className="text-sm text-green-600">View spending patterns</p>
          </div>
          <PlusCircle className="w-6 h-6 text-green-600" />
        </CardContent>
      </Card>
    </div>
  );
}
